import { Outlet } from 'react-router-dom';
import { notification } from 'antd';
import globalNotification from '../../common/hooks/globalNotification';
import { useTranslation } from 'react-i18next';
import { buildRequestNotificationText } from './requestNotificationText';
import { ImpersonationOverlay } from '../impersonation/ImpersonationOverlay';
import { isImpersonationTab } from '../../services/impersonationSession';

export const NotificationLayer = () => {
    const { t } = useTranslation(['general', 'notifications']);

    // For displaying a notification and calling it from a component, use globalNotification.open() with the required parameters
    const [api, contextHolder] = notification.useNotification();
    // a key replaces an open notification with the same key instead of stacking another one
    const openNotification = ({ type = 'error', message = '', description = '', placement = 'top', key }) => {
        api[type]({
            key,
            message: message,
            description: description,
            placement: placement,
        });
    };

    const requestNotification = ({ type, resource, action, plural }) => {
        api[type]({
            ...buildRequestNotificationText(t, { type, resource, action, plural }),
            placement: 'top',
        });
    };

    globalNotification.open = openNotification;
    globalNotification.request = requestNotification;

    return (
        <>
            {contextHolder}
            {isImpersonationTab() && <ImpersonationOverlay />}
            <Outlet />
        </>
    );
};
